import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setFillExampleModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';

const FillExampleModal: React.FC<IProps> = (props) => {
  const handleClose = () => {
    props.setFillExampleModalVisible(false);
  };

  return (
    <>
      {props.modal.fillExampleModalVisible && (
        <div className="fill-example-modal">
          <Modal
            visible={props.modal.fillExampleModalVisible}
            title={props.title ?? '如何填寫'}
            confirmButton={false}
            onCancel={handleClose}
            idName="fill-example-modal"
          >
            <div className="fill-example-modal__example-image" />
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFillExampleModalVisible: (visible: boolean) => dispatch(setFillExampleModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(FillExampleModal);
